import { LayoutCMS } from 'components/';
import React, { useEffect } from 'react';
import { Card } from 'asumsi-components';
import moment from 'moment';
import { Link } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { Breadcrumb } from 'antd';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    button: {
      margin: theme.spacing(1),
      background: "#E56183",
      border: "1px solid #E56183",
      color: "#FFFFFF",
    },
    div: {
      display: "flex"
    },
    link: {
      marginLeft: "auto"
    }
  }),
);
export const PageDashboardComponent = (props: any) => {
  const classes = useStyles();
  const title: string = "Dashboard";
  const layoutCMSProps = {
    breadcrumb: (
      <>
          <Breadcrumb.Item>
              {title}
          </Breadcrumb.Item>
      </>
    ),
    documentTitle: title,
    pageTitle: title,
    history: props.history
  };

  useEffect(() => {
    const dateNow: string = moment().format("YYYY-MM-DD").toString();
    getData(dateNow);
  }, []);

  const getData = async (date: string) => {
    // Do request get data 
  }

  return (
    <LayoutCMS {...layoutCMSProps}>
      <Card className="asumsi-card-form-shadow-rd-15">
        <div className={classes.div}>
          <h2>Website Overview</h2>
          <Link target="_blank" to="//datastudio.google.com/reporting/a9e01974-da46-4ed3-a22d-2a72612f5f7f" className={classes.link}>
              <Button variant="contained" color="secondary" className={classes.button} startIcon={ < OpenInNewIcon /> }>Open in New Tab</Button>
          </Link>
        </div>
        <p>Overview of website performances based on Google Analytics</p>
      </Card><br/>
      <Card className="asumsi-card-form-shadow-rd-15">
        <div className={classes.div}>
          <h2>Search Console Report</h2>
          <Link target="_blank" to="//datastudio.google.com/reporting/459294c0-a983-4882-9886-ffd50104656d" className={classes.link}>
              <Button variant="contained" color="secondary" className={classes.button} startIcon={ < OpenInNewIcon /> }>Open in New Tab</Button>
          </Link>
        </div>
        <p>Query and landing page performances based on Google Search Console</p>
      </Card>
    </LayoutCMS >
  );
};

export default PageDashboardComponent;



// WEBPACK FOOTER //
// ./src/pages/dashboard/component.tsx